import { getAdministratorMenuItems } from './admin';
import {admin_exams} from './exams';

// This function will be called with the AI evaluation enabled state
export const getAdminMenuItems = (aiEvaluationEnabled = false, isOperator = false) => {
  return {
    items: [getAdministratorMenuItems(aiEvaluationEnabled, isOperator), admin_exams]
  };
};

// Default export for backward compatibility
const menuItems = getAdminMenuItems(false);
export default menuItems;
